import { CompanyCredits } from 'src/services/ds.service'
import { ofType, unionize, UnionOf } from 'src/framework'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'

export interface GetCompanyCredits {
  type: 'GetCompanyCredits'
  token: string
  [startFetch]: string
}

export interface GetCompanyCreditsSuccess {
  type: 'GetCompanyCreditsSuccess'
  credits: CompanyCredits[]
  [stopFetch]: string
}

export interface GetCompanyCreditsFailed {
  type: 'GetCompanyCreditsFailed'
  [stopFetch]: string
}

export const structureHomeActions = unionize({
  ...ofType<GetCompanyCredits>('GetCompanyCredits'),
  ...ofType<GetCompanyCreditsSuccess>('GetCompanyCreditsSuccess'),
  ...ofType<GetCompanyCreditsFailed>('GetCompanyCreditsFailed')
})

export type StructureHomeActions = UnionOf<typeof structureHomeActions>



// WEBPACK FOOTER //
// ./src/home/structure/structure-home.actions.ts